import { useEffect, useState } from 'react'
import { getDirections } from './api'
import { fetchData } from '../../../../../global/helper-functions/fetch'
import styles from './styles.module.css'
import { IInstallationPoint } from '../../../../../../../app/entities/InstallationPoint'

export default function DrivingDetails({
  chosenAddress,
  installationPoint,
  setInstallationPoint,
}: {
  chosenAddress: google.maps.GeocoderResult | null
  installationPoint?: IInstallationPoint
  setInstallationPoint: Function
}) {
  const [message, setMessage] = useState<string>('Getting driving details...')

  const selectedLocationObjectId = localStorage.getItem(
    'selectedLocationObjectId',
  )

  useEffect(() => {
    if (!selectedLocationObjectId) {
      setMessage('No location selected, please refresh page and try again.')
    }
  }, [])

  useEffect(() => {
    // if we already have the driving details, we don't need to get them again
    if (installationPoint?.drivingDetails) {
      return setMessage(
        `${installationPoint.drivingDetails.distance?.text} - ${installationPoint.drivingDetails.duration?.text} from store`,
      )
    }

    // if we don't have the address or the location, we can't get the driving details
    if (!chosenAddress?.place_id || !selectedLocationObjectId) return

    const call = async () => {
      const response = await fetchData<{
        status: google.maps.GeocoderStatus
        geocoded_waypoints: google.maps.DirectionsGeocodedWaypoint[]
        routes: google.maps.DirectionsRoute[]
      }>(
        getDirections(
          selectedLocationObjectId || '',
          chosenAddress?.place_id || '',
        ),
      )

      if (response.status !== 'OK') {
        setMessage(
          'No route available. Check address and location and try again.',
        )
      } else {
        // removing steps here since it can be a huge array and actually
        // prevent scheduling
        const { steps, ...drivingDetails } = response.routes[0].legs[0]

        setInstallationPoint((prev: IInstallationPoint) => ({
          ...prev,
          drivingDetails,
        }))

        setMessage(
          `${drivingDetails.distance?.text} - ${drivingDetails.duration?.text} from store`,
        )
      }
    }

    call()
  }, [chosenAddress, selectedLocationObjectId])

  return (
    <div className={styles.drivingDetailsContainer}>
      <div className={styles.drivingDetailsMessage}>{message}</div>
    </div>
  )
}
